import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Bar as BarComponent } from '@ow/charts/lib'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import * as echarts from 'echarts'
import { cloneDeep } from 'lodash-es'
import NullData from './nullData'

const Bar = function ({ data, customDsl }) {
  const [itemData, setItemData] = useState({})
  const { appId } = useParams()
  useEffect(() => {
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        const xAxis = res.map((r) => r.name)
        const yAxis = [{ data: res.map((r) => r.value), name: '数量' }]
        setItemData({ xAxis, yAxis })
      })
  }, [customDsl, data])

  return (
    <div className="h-full w-full">
      {Object.keys(itemData).length === 0 && <NullData />}
      {Object.keys(itemData).length !== 0 && (
        <BarComponent
          id="bar"
          width="100%"
          height="100%"
          data={itemData}
          color={['#34CCFF', '#54D880']}
          axisXLine={{
            show: false,
          }}
          axisYLine={{
            show: false,
          }}
          splitYLine={{
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.15)',
            },
          }}
          rotate={30}
          showLegend={false}
          labelColor="#fff"
          series={{
            barWidth: 20,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(95, 255, 240, 0.89)' },
                { offset: 0.7, color: 'rgba(35,156,225,0.82)' },
                { offset: 1, color: '#405FDC' },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: 'rgba(95, 255, 240, 0.89)' },
                ]),
              },
            },
          }}
        />
      )}
    </div>
  )
}

export default Bar
